import React from "react";
import { Link } from "react-router-dom";

const FooterFive = () => {
  return (
    <section className='bg-white z-5'>
      <div className='pb-120'>
        <div className='container max-w-1536-px'>
          <div className='row row-cols-xxl-5 row-cols-lg-3 row-cols-sm-2 row-cols-1 gy-4'>
            <div className='col' data-aos='fade-up' data-aos-duration={600}>
              <img 
                src='assets/images/logo/logo-kusuma.png' 
                alt='Logo Bimbel Kusuma' 
                className='mb-24' 
              />
              <div>
                <p className='text-neutral-700 text-14 fw-normal mb-24 max-w-240-px'>
                  Bimbel Kusuma hadir dengan 330 guru professional untuk memberikan pendampingan belajar berkualitas di Kudus, Demak, Pati, Jepara dan Solo Raya.
                </p>
                <ul className='d-flex align-items-center gap-12'>
                  <li>
                    <a
                      href='https://wa.me/082131569957'
                      className='w-32 h-32 border-main-600 border rounded-circle text-16 hover-bg-main-600 hover-text-white transition-04 align-items-center justify-content-center d-flex'
                    >
                      <i className='ph ph-whatsapp-logo' />
                    </a>
                  </li>
                  <li>
                    <a
                      href='https://www.instagram.com/bimbelkusuma'
                      className='w-32 h-32 border-main-600 border rounded-circle text-16 hover-bg-main-600 hover-text-white transition-04 align-items-center justify-content-center d-flex'
                    >
                      <i className='ph ph-instagram-logo' />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            {/* <div className='col' data-aos='fade-up' data-aos-duration={700}>
              <h4 className='text-black mb-24'>Menu Utama</h4>
              <div>
                <ul>
                  <li className='item-hover position-relative mb-16'>
                    <Link
                      to='/about'
                      className='hover-margin-left d-flex align-items-center text-neutral-700 text-16 fw-normal hover-text-warning-600'
                    >
                      <span className='position-absolute top-50 start-0 translate-middle w-8 h-8 bg-warning-600 rounded-circle transition-03 hidden group-hover-visible' />
                      Tentang Kami
                    </Link>
                  </li>
                  <li className='item-hover position-relative mb-16'>
                    <Link
                      to='/program'
                      className='hover-margin-left d-flex align-items-center text-neutral-700 text-16 fw-normal hover-text-warning-600'
                    >
                      <span className='position-absolute top-50 start-0 translate-middle w-8 h-8 bg-warning-600 rounded-circle transition-03 hidden group-hover-visible' />
                      Program Les
                    </Link>
                  </li>
                  <li className='item-hover position-relative mb-16'>
                    <Link
                      to='/guru'
                      className='hover-margin-left d-flex align-items-center text-neutral-700 text-16 fw-normal hover-text-warning-600'
                    >
                      <span className='position-absolute top-50 start-0 translate-middle w-8 h-8 bg-warning-600 rounded-circle transition-03 hidden group-hover-visible' />
                      Tim Pengajar
                    </Link>
                  </li>
                  <li className='item-hover position-relative'>
                    <Link
                      to='/faq'
                      className='hover-margin-left d-flex align-items-center text-neutral-700 text-16 fw-normal hover-text-warning-600'
                    >
                      <span className='position-absolute top-50 start-0 translate-middle w-8 h-8 bg-warning-600 rounded-circle transition-03 hidden group-hover-visible' />
                      FAQ
                    </Link>
                  </li>
                </ul>
              </div>
            </div> */}
            <div className='col' data-aos='fade-up' data-aos-duration={1000}>
              <h4 className='text-black mb-24'>Hubungi Kami</h4>
              <div className='mb-16'>
                <div className='d-flex align-items-center gap-16'>
                  <span className='w-40 h-40 border-main-600 border rounded-circle text-neutral-700 justify-content-center align-items-center d-flex flex-shrink-0'>
                    <i className='ph-bold ph-phone' />
                  </span>
                  <a
                    href='tel:082131569957'
                    className='text-neutral-700 hover-text-warning-800'
                  >
                    0821-3156-9957
                  </a>
                </div>
              </div>
              <div className='mb-16'>
                <div className='d-flex align-items-center gap-16'>
                  <span className='w-40 h-40 border-main-600 border rounded-circle text-neutral-700 justify-content-center align-items-center d-flex flex-shrink-0'>
                    <i className='ph-bold ph-envelope-open' />
                  </span>
                  <a
                    href='mailto:bimbelkusuma@gmail.com'
                    className='text-neutral-700 hover-text-warning-800'
                  >
                    bimbelkusumaofficial@gmail.com
                  </a>
                </div>
              </div>
              <div>
                <div className='d-flex align-items-center gap-16'>
                  <span className='w-40 h-40 border-main-600 border rounded-circle text-neutral-700 justify-content-center align-items-center d-flex flex-shrink-0'>
                    <i className='ph-bold ph-link' />
                  </span>
                  <a
                    href='https://linktr.ee/bimbelkusuma'
                    className='text-neutral-700 hover-text-warning-800'
                  >
                    linktr.ee/bimbelkusuma
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='container max-w-1536-px position-relative z-2'>
        <div className='py-32 border-top border-white'>
          <p className='text-16 fw-semibold text-neutral-700 text-center'>
            Copyright ©2025 PT. Inovasi Denta Kusuma. All Rights Reserved.
          </p>
        </div>
      </div>
      <div className='position-absolute bottom-0 start-0 w-100 z-1'>
        <img
          src='assets/images/shapes/cloud-shap-img5.png'
          alt=''
          className='w-100'
        />
      </div>
    </section>
  );
};

export default FooterFive;
